import { render, staticRenderFns } from "./publish_result_dialog.vue?vue&type=template&id=38dbe0d5&scoped=true"
import script from "./publish_result_dialog.vue?vue&type=script&lang=js"
export * from "./publish_result_dialog.vue?vue&type=script&lang=js"
import style0 from "./publish_result_dialog.vue?vue&type=style&index=0&id=38dbe0d5&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38dbe0d5",
  null
  
)

export default component.exports